import React, { useEffect, useState } from "react";
import {
  Form,
  Input,
  Select,
  Button,
  Row,
  Col,
  DatePicker,
  InputNumber,
  Collapse,
  Upload,
  Checkbox,
  Typography,
  Space,
} from "antd";
import { UploadOutlined } from "@ant-design/icons";
import ReactPhoneInput from "react-phone-input-2";
import { useDispatch, useSelector } from "react-redux";
import { fetchSingleOnboarding, saveOnboarding } from "../onboardingThunks";
import { useLocation, useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import { getISOFromCountryName } from "../../../lib/currency";
import { selectAuthInfo } from "../../Auth/authSelectors";
import '../onboard-style.css';
import { fetchDepartments, fetchDesignations } from "../../Employees/employeeThunks";
import { fetchEmployees } from "../../Employees/employeeThunks";
import Loading from "../../../components/Loading";
import Swal from "sweetalert2";
import { clearSingle } from "../onboardingSlice";

const { Panel } = Collapse;
const { Title } = Typography;
const { Option } = Select;

const OnboardingForm = () => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const authInfo = useSelector(selectAuthInfo);

  const [salaryComponents, setSalaryComponents] = useState([
  { name: "Basic Salary", amount: 0, isBasic: true }
]);

const [customAllowance, setCustomAllowance] = useState("");
const [showAllowanceInput, setShowAllowanceInput] = useState(false);
const [allowanceOptions, setAllowanceOptions] = useState([
  "Housing Allowance",
  "Transport Allowance",
  "Bonus"
]);
const [selectedAllowance, setSelectedAllowance] = useState(null);
  const [offerGiven, setOfferGiven] = useState(false);
  const [offerSigned, setOfferSigned] = useState(false);
//   const [form, setForm] = useState({});

  const defaultCountry = getISOFromCountryName(authInfo?.country);

  const location = useLocation();
  const onboardingId = location.state?.id;

  const { single, loading  } = useSelector((s) => s.onboarding);

  const {
      list: employees = [],      
      departments = [],
      designations = [],      
    } = useSelector((s) => s.employees || {});

    const normFile = (e) => {
    if (Array.isArray(e)) return e;
    return e?.fileList;
  };


//   const addAllowance = () => {
//     setSalary([...salary, { name: "", amount: 0 }]);
//   };


  useEffect(() => {
    dispatch(fetchDepartments());
    dispatch(fetchDesignations());   
    dispatch(fetchEmployees());  
  }, [dispatch]);

  // on Edit
  useEffect(() => {
    if (onboardingId) {
      dispatch(fetchSingleOnboarding(onboardingId));
    }
  }, [onboardingId, dispatch]);

  useEffect(() => {    
      if (onboardingId && single) {
        console.log(onboardingId)
        form.setFieldsValue({
          ...single,
          joining_date: single.joining_date
            ? dayjs(single.joining_date)
            : null,
          // ✅ FIX BOOLEAN FIELDS
          offer_letter_given: !!single.offer_letter_given,
          offer_signed: !!single.offer_signed,  
        });

        // ✅ Salary mapping
        if (single.allowance_values) {
          const allowances = single.allowance_values.map((a) => ({
            name: a.name.replace(/_/g, " "),
            amount: a.amount,
          }));

          setSalaryComponents([
            {
              name: "Basic Salary",
              amount: single.basic_salary || 0,
              isBasic: true,
            },
            ...allowances,
          ]);
        }
            
          // uploaded file
        if (single.offer_letter_file && typeof single.offer_letter_file === "string") {
          form.setFieldsValue({
            offer_letter_file: [
              {
                uid: "-1",
                name: single.offer_letter_file.split("/").pop(),
                status: "done",
                url: single.offer_letter_file,
              },
            ],
          });
        }

        if (single.offer_signed_file && typeof single.offer_signed_file === "string") {
          form.setFieldsValue({
             offer_signed_file: [
              {
                uid: "-2",
                name: single.offer_signed_file.split("/").pop(),
                status: "done",
                url: single.offer_signed_file,
              },
            ],
          });
        }   
        
      }
  
    }, [single, onboardingId, dispatch, form]);

    useEffect(() => {
      if (!onboardingId) {
        // ✅ CLEAR EVERYTHING
        dispatch(clearSingle());
        form.resetFields();

        setSalaryComponents([
          { name: "Basic Salary", amount: 0, isBasic: true }
        ]);

        // clear file fields
        form.setFieldsValue({
          offer_letter_file: undefined,
          offer_signed_file: undefined,
        });
      }
    }, [onboardingId, form, dispatch]);

    useEffect(() => {
      return () => {
        form.resetFields();
      };
    }, [form]);

//   useEffect(() => {
//   if (editData) {
//     form.setFieldsValue({
//       ...editData,
//       joining_date: editData.joining_date
//         ? dayjs(editData.joining_date)
//         : null,
//     });

//     // ✅ Salary components mapping
//     if (editData.allowance_values) {
//       const allowances = editData.allowance_values.map((a) => ({
//         name: a.name.replace(/_/g, " "),
//         amount: a.amount,
//       }));

//       setSalaryComponents([
//         {
//           name: "Basic Salary",
//           amount: editData.basic_salary || 0,
//           isBasic: true,
//         },
//         ...allowances,
//       ]);
//     }

//     // uploaded file
//     if (editData.offer_letter_file) {
//       form.setFieldsValue({
//         offer_letter_file: [
//           {
//             uid: "-1",
//             name: editData.offer_letter_file.split("/").pop(),
//             status: "done",
//             url: editData.offer_letter_file,
//           },
//         ],
//       });
//     }

//     if (editData.offer_signed_file) {
//       form.setFieldsValue({
//         offer_signed_file: [
//           {
//             uid: "-1",
//             name: editData.offer_signed_file.split("/").pop(),
//             status: "done",
//             url: editData.offer_signed_file,
//           },
//         ],
//       });
//     }
//   }
// }, [editData, form]);

 const handleSave = async () => {
  try {
    const values = await form.validateFields();

    console.log("FORM VALUES:", values);

    const formData = new FormData();
    
    const {
      offer_letter_file,
      offer_signed_file,
      ...restValues
    } = values;

    const payload = {
      id: single?.id, //during it sends id
      ...restValues,
      joining_date: values.joining_date
        ? dayjs(values.joining_date).format("YYYY-MM-DD")
        : null,
      basic_salary:
        salaryComponents.find((s) => s.isBasic)?.amount || 0,
      total_monthly_salary: salaryComponents.reduce(
        (sum, s) => sum + (s.amount || 0),
        0
      ),
      selected_allowances: salaryComponents
        .filter((s) => !s.isBasic)
        .map((s) => s.name.replace(/\s+/g, "_")),
      allowance_values: salaryComponents
        .filter((s) => !s.isBasic)
        .map((s) => ({
          name: s.name.replace(/\s+/g, "_"),
          amount: s.amount,
        })),
    };

    formData.append("jsonData", JSON.stringify(payload));
    
    // ✅ FILES handled separately
    if (offer_letter_file?.[0]?.originFileObj) {
      formData.append(
        "offer_letter_file",
        offer_letter_file?.[0]?.originFileObj
      );
    }

    if (offer_signed_file?.[0]?.originFileObj) {
      formData.append(
        "offer_signed_file",
        offer_signed_file?.[0]?.originFileObj
      );
    }

    const res = await dispatch(saveOnboarding(formData)).unwrap();
    console.log(res)
    Swal.fire({
      icon:"success",
      title:res.msg
    })

    navigate("/hrpayroll/onboarding");

  } catch (err) {
    console.log("Validation/API Error:", err);
  }
};

  const handleConvert = () => {
    navigate("/employees", {
      state: {
        onboardingData: {
          employee_name: form.full_name,
          email_address: form.email,
          contact_no: form.mobile,
          gender_type: form.gender_type,
          marital_type: form.marital_type,
          department_id: form.department_id,
          designation_id: form.designation_id,
          joining_date: form.joining_date,
          basic_salary: form.basic_salary,
          total_monthly_salary: form.total_monthly_salary,
          selected_allowances: salaryComponents
        .filter(s => !s.isBasic)
        .map(s => s.name.replace(/\s+/g, "_")),

    allowance_values: salaryComponents
        .filter(s => !s.isBasic)
        .map(s => ({
        name: s.name.replace(/\s+/g, "_"),
        amount: s.amount
        })),
          onboarding_id: form.id,
        },
      },
    });
  };

  if (loading) return <Loading />;

  const isConverted = single?.status === "converted";

  return (
    <div className="onboarding-entry">
      <Title level={3}>Create Onboarding</Title>

      <Form key={onboardingId ? onboardingId : "new"} form={form} layout="vertical" disabled={isConverted}>
  <Collapse defaultActiveKey={["1"]}>

    {/* BASIC */}
    <Panel header="Basic Information" key="1">
      <Row gutter={16}>
        <Col xs={24} md={12}>
          <Form.Item
            name="full_name"
            label="Full Name"
            rules={[{ required: true, message: "Full Name is required" }]}
          >
            <Input />
          </Form.Item>
        </Col>

        <Col xs={24} md={12}>
          <Form.Item name="email" label="Email">
            <Input />
          </Form.Item>
        </Col>

        <Col xs={24} md={12}>
        <Form.Item label="Contact No" >
          <Form.Item name="country_code" hidden />
        <Form.Item name="phone_no" hidden />

        <ReactPhoneInput
          country={defaultCountry}
          value={
            form.getFieldValue("country_code")
              ? `+${form.getFieldValue("country_code")} ${form.getFieldValue("phone_no") || ""}`
              : ""
          }
          onChange={(value, countryData) => {
            const code = countryData.dialCode;
            const phone = value.replace(`+${code}`, "").trim();

            form.setFieldsValue({
              country_code: code,
              phone_no: phone,
            });
          }}
        />
        </Form.Item>
        </Col>

        <Col xs={24} md={12}>
        <Form.Item label="Emergency Phone No" >
          <Form.Item name="secondary_country_code" hidden />
            <Form.Item name="secondary_phone_no" hidden />

            <ReactPhoneInput
            country={defaultCountry}
              value={
                form.getFieldValue("secondary_country_code")
                  ? `+${form.getFieldValue("secondary_country_code")} ${form.getFieldValue("secondary_phone_no") || ""}`
                  : ""
              }
              onChange={(value, countryData) => {
                const code = countryData.dialCode;
                const phone = value.replace(`+${code}`, "").trim();

                form.setFieldsValue({
                  secondary_country_code: code,
                  secondary_phone_no: phone,
                });
              }}
            />
          </Form.Item>
        </Col>

        <Col xs={24} md={12}>
          <Form.Item name="gender_type" label="Gender">
            <Select>
              <Option value="male">Male</Option>
              <Option value="fmale">Female</Option>
              <Option value="others">Others</Option>
            </Select>
          </Form.Item>
        </Col>

        <Col xs={24} md={12}>
          <Form.Item name="marital_type" label="Marital Status">
            <Select>
              <Option value="single">Single</Option>
              <Option value="married">Married</Option>
            </Select>
          </Form.Item>
        </Col>

        <Col span={24}>
          <Form.Item name="present_address" label="Present Address">
            <Input.TextArea />
          </Form.Item>

        </Col>

        <Col span={24}>
          <Form.Item name="permanent_address" label="Permanent Address">
            <Input.TextArea />
          </Form.Item>
        </Col>
      </Row>
    </Panel>

    {/* JOB */}
    <Panel header="Job Details" key="2">
      <Row gutter={16}>

        <Col xs={24} md={12}>
          <Form.Item name="joining_date" label="Joining Date">
            <DatePicker style={{ width: "100%" }} />
          </Form.Item>
        </Col>

        {/* ✅ KEEP YOUR EXISTING DATA */}
        <Col xs={24} md={12}>
          <Form.Item name="department_id" label="Department">
            <Select>
              {departments?.map((d) => (
                <Option key={d.id} value={d.id}>
                  {d.name}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>

        <Col xs={24} md={12}>
          <Form.Item name="designation_id" label="Designation">
            <Select>
              {designations?.map((d) => (
                <Option key={d.id} value={d.id}>
                  {d.name}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>

        <Col xs={24} md={12}>
          <Form.Item name="reporting_manager" label="Reporting Manager">
            <Select showSearch optionFilterProp="children">
              {employees?.map((emp) => (
                <Option key={emp.employee_id} value={emp.employee_id}>
                  {emp.employee_name}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>

        <Col xs={24} md={12}>
          <Form.Item name="employment_type" label="Employment Type">
            <Select>
              <Option value="ftime">Full Time</Option>
              <Option value="ptime">Part Time</Option>
              <Option value="contract">Contract</Option>
            </Select>
          </Form.Item>
        </Col>

        <Col xs={24} md={12}>
          <Form.Item name="work_location" label="Work Location">
            <Select>
              <Option value="office">Office</Option>
              <Option value="remote">Remote</Option>
              <Option value="hybrid">Hybrid</Option>
            </Select>
          </Form.Item>
        </Col>

        <Col xs={24}>
          <Form.Item name="job_grade" label="Job Grade">
            <Input />
          </Form.Item>
        </Col>
      </Row>
    </Panel>

    {/* SALARY */}
    <Panel header="Salary Breakup" key="3">

  {/* ADD ALLOWANCE */}
  <Select
  value={selectedAllowance}
  placeholder="Select Allowance"
  style={{ width: "100%", marginBottom: 16 }}
  allowClear
  popupRender={(menu) => (
    <>
      {menu}

      <div style={{ padding: 10, borderTop: "1px solid #eee" }}>
        {showAllowanceInput ? (
          <Space style={{ width: "100%" }}>
            <Input
              placeholder="New allowance"
              value={customAllowance}
              onChange={(e) => setCustomAllowance(e.target.value)}
            />
            <Button
              type="primary"
              onClick={() => {
                if (!customAllowance) return;

                const newOption = customAllowance.trim();

                // add to dropdown
                setAllowanceOptions([...allowanceOptions, newOption]);

                // add to table immediately
                setSalaryComponents([
                  ...salaryComponents,
                  { name: newOption, amount: 0 }
                ]);

                setCustomAllowance("");
                setShowAllowanceInput(false);
              }}
            >
              Add
            </Button>
          </Space>
        ) : (
          <Button
            type="text"
            style={{ width: "100%", textAlign: "left" }}
            onClick={() => setShowAllowanceInput(true)}
          >
            ➕ Add New Allowance
          </Button>
        )}
      </div>
    </>
  )}
  onChange={(value) => {
    if (salaryComponents.find((s) => s.name === value)) return;

    setSalaryComponents([
      ...salaryComponents,
      { name: value, amount: 0 }
    ]);
    setSelectedAllowance(null);
  }}
>
  {allowanceOptions.map((opt) => (
    <Option key={opt} value={opt}>
      {opt}
    </Option>
  ))}
</Select>

  {/* TABLE HEADER */}
  <div className="salary-table-header">
    <span>Salary Component</span>
    <span>Amount</span>
    <span>Action</span>
  </div>

  {/* ROWS */}
  {salaryComponents.map((item, index) => (
    <div key={index} className="salary-row-table">

      {/* NAME */}
      <span className="component-name">{item.name}</span>

      {/* AMOUNT */}
      <InputNumber
        value={item.amount}
        style={{ width: "100%" }}
        onClick={() => {
          const updated = [...salaryComponents];

          if (updated[index].amount === 0) {
            updated[index].amount = "";
            setSalaryComponents(updated);
          }
        }}
        onChange={(val) => {
          const updated = [...salaryComponents];
          updated[index].amount = val || 0;
          setSalaryComponents(updated);
        }}
      />

      {/* ACTION */}
      <span>
        {!item.isBasic && (
          <Button
            danger
            type="link"
            onClick={() => {
              setSalaryComponents(
                salaryComponents.filter((_, i) => i !== index)
              );
            }}
          >
            Remove
          </Button>
        )}
      </span>
    </div>
  ))}

  {/* TOTAL */}
  <div className="salary-total">
    <strong>
      Total Monthly Salary:{" "}
      {salaryComponents.reduce((sum, s) => sum + (s.amount || 0), 0)}
    </strong>
  </div>

</Panel>

    {/* DOCUMENTS */}
    <Panel header="Onboarding Documents" key="4">
  <Row gutter={[16, 16]}>

    {/* OFFER LETTER GIVEN */}
    <Col xs={24} md={12}>
      <Form.Item
        name="offer_letter_given"
        valuePropName="checked"
      >
        <Checkbox>Offer Letter Given</Checkbox>
      </Form.Item>

      <Form.Item shouldUpdate={(prev, curr) =>
        prev.offer_letter_given !== curr.offer_letter_given
      }>
        {({ getFieldValue }) =>
          getFieldValue("offer_letter_given") && (
            <Form.Item name="offer_letter_file" valuePropName="fileList" getValueFromEvent={normFile}>
              <Upload beforeUpload={() => false} maxCount={1}>
                <Button icon={<UploadOutlined />}>
                  Upload Offer Letter
                </Button>
              </Upload>
            </Form.Item>
          )
        }
      </Form.Item>
    </Col>

    {/* OFFER LETTER SIGNED */}
    <Col xs={24} md={12}>
      <Form.Item
        name="offer_signed"
        valuePropName="checked"
      >
        <Checkbox>Offer Letter Signed</Checkbox>
      </Form.Item>

      <Form.Item shouldUpdate={(prev, curr) =>
        prev.offer_signed !== curr.offer_signed
      }>
        {({ getFieldValue }) =>
          getFieldValue("offer_signed") && (
            <Form.Item name="offer_signed_file" valuePropName="fileList" getValueFromEvent={normFile}>
              <Upload beforeUpload={() => false} maxCount={1}>
                <Button icon={<UploadOutlined />}>
                  Upload Signed Copy
                </Button>
              </Upload>
            </Form.Item>
          )
        }
      </Form.Item>
    </Col>

  </Row>
</Panel>

  </Collapse>

  <Space style={{ marginTop: 20 }}>
    <Button onClick={() => navigate(-1)}>Back</Button>
    <Button type="primary" onClick={handleSave} disabled={isConverted}>Save</Button>
  </Space>
</Form>
    </div>
  );
};

export default OnboardingForm;